import React, { useState } from 'react';
import { registerWithEmail } from '../services/auth';
import { useNavigate, Link } from 'react-router-dom';
import { doc, setDoc } from 'firebase/firestore';
import { firestore } from '../services/firebase';
import '../styles/Auth.css';

export default function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rePassword, setRePassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validatePassword = (password) => {
    const regex = /^[a-zA-Z0-9]{8,}$/;
    return regex.test(password);
  };

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleInputChange = (setter) => (e) => {
    setError('');
    setter(e.target.value);
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    if (password !== rePassword) {
      setError("Passwords do not match.");
      return;
    }
    if (!validatePassword(password)) {
      setError("Password must be at least 8 characters long and contain only letters and numbers.");
      return;
    }
    if (!validateEmail(email)) {
      setError("Invalid email format.");
      return;
    }

    setLoading(true);
    try {
      const user = await registerWithEmail(email, password, fullName);

      // Add user data to Firestore
      const userRef = doc(firestore, 'users', user.uid);
      await setDoc(userRef, {
        fullName,
        email,
        createdAt: new Date().toISOString(),
      });

      navigate("/taskBoard");
    } catch (err) {
      setError(`Registration failed: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-welcome">
            <h1 className="auth-welcome-title">Join Us! 🚀</h1>
            <p className="auth-welcome-subtitle">Start your journey to peak productivity</p>
          </div>
          <h2 className="auth-title">Register</h2>
          <form onSubmit={handleRegister} className="auth-form">
            <div className="form-group">
              <label htmlFor="fullName">Full Name</label>
              <input
                type="text"
                id="fullName"
                data-testid="fullname-input"
                value={fullName}
                onChange={handleInputChange(setFullName)}
                placeholder="Enter your full name"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <input
                type="email"
                id="email"
                data-testid="email-input"
                value={email}
                onChange={handleInputChange(setEmail)}
                placeholder="Enter your email"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                data-testid="password-input"
                value={password}
                onChange={handleInputChange(setPassword)}
                placeholder="Enter your password"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="rePassword">Confirm Password</label>
              <input
                type="password"
                id="rePassword"
                data-testid="repassword-input"
                value={rePassword}
                onChange={handleInputChange(setRePassword)}
                placeholder="Confirm your password"
                required
              />
            </div>
            {error && <div className="auth-error" data-testid="error-msg">{error}</div>}
            <button type="submit" className="auth-submit-btn" data-testid="register-btn" disabled={loading}>
              {loading ? 'Registering...' : 'Register'}
            </button>
          </form>

          <div className="auth-link-text">
            <span>Already have an account? </span>
            <Link to="/login">Login here</Link>
          </div>
        </div>
      </div>
    </div>
  );
}


